import Component from '../../shared/component';

export default class OnboardingTiles extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$tiles = $('.onboardingTiles-tile');
    this.$closeButton = $('.onboardingTiles-close');

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.$tiles.on('click', this.handleClick);
    this.$closeButton.on('click', this.handleClose);
  }

  unbindEvents() {
    this.$tiles.off('click', this.handleClick);
    this.$closeButton.off('click', this.handleClose);
  }

  handleClick(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);

    window.Turbolinks.visit(`${$target.attr('href')}?onboarding_splash=1`);
  }

  handleClose(event) {
    event.preventDefault();

    this.markOnboardingAsSeen(() => {
      window.Turbolinks.reload({keepScrollPosition: true});
    });
  }

  markOnboardingAsSeen(callback) {
    const url = this.$element.data('completion-url');

    $.ajax({
      url,
      type: 'PUT',
      // eslint-disable-next-line camelcase
      data: {user: {onboarding_seen: 'true'}},
      dataType: 'json',
    }).always(callback);
  }
}
